import React from "react";
import useReveal from "@/hooks/useReveal";

function SectionHeading({ eyebrow, title, accent, children, rightSlot, testId }) {
  const r = useReveal();
  return (
    <div
      ref={r.ref}
      className={`flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 ${r.className}`}
      data-testid={testId}
    >
      <div style={{ maxWidth: 720 }}>
        <div className="eyebrow">{eyebrow}</div>
        <h2 className="section-title mt-5">
          {title} {accent && <span className="accent">{accent}</span>}
        </h2>
        {children && <p className="section-copy mt-5">{children}</p>}
      </div>
      {rightSlot && <div className="flex-shrink-0">{rightSlot}</div>}
    </div>
  );
}

export default SectionHeading;
